import "../../Css/MenuWide.css";
import MenuItem from './MenuItem';
import { Link } from "react-router-dom";
import { Fragment } from "react";
import { InfoSquare, Power, PersonCircle, HouseDoor, Key, Globe2, Person, PhoneVibrate } from 'react-bootstrap-icons';
import { useDispatch } from "react-redux";
const pkg = require('../../../package.json');
const MenuWide = (props) => {
  const dispatch = useDispatch();
  const company = JSON.parse(localStorage.getItem("Company"));
  const { menuWidth, setMenuWidth, setModalAboutUs } = props;
  const userInfo = JSON.parse(localStorage.getItem("UserInfo"));
  const closeMenu = () => {
    setMenuWidth(0);
  }
  function logOut() {
    localStorage.removeItem("token");
    localStorage.removeItem("LastServiceID");
    localStorage.removeItem("LastServiceType");
    localStorage.removeItem("SystemID");
    localStorage.removeItem("now");
  }
  return (
    <Fragment>
      <div style={{ width: menuWidth }} className="sidenav">
        <div style={{ position: "absolute", top: "0", right: "20px" }}>
          <PersonCircle size={22} color="rgb(115, 57, 141)" style={{ float: "right", marginTop: "13px" }} />
          {<span style={{ float: "right", marginTop: "15px", marginRight: "5px", color: "rgb(115, 57, 141)", textAlign: "right", maxWidth: "120px", maxHeight: "20px", overflow: "hidden" }}>{userInfo?.Name}</span>}
        </div>
        <p className="closebtn" style={{ cursor: "pointer" }} onClick={closeMenu}>&times;</p>
        <Link to="/" onClick={closeMenu} className="homeHomeBtn" >
          <HouseDoor title="منوی اصلی" style={{ color:'#3c00ff' }} size={22} />
        </Link>
        <a href='/' onClick={logOut} className="logoutBtn">
          <Power style={{ color: 'red' }} size={22} />
        </a>
        <div style={{ display: menuWidth != "0" ? "block" : "none" }}>

          <MenuItem title="" className="openedMenu" items={[
            { type: "a", href: company?.AboutUS, text: "درباره ما", onClick: closeMenu, icon: <InfoSquare style={{ marginTop: "6px", color: 'rgb(8 120 110)' }} size={16} /> },
            { type: "a", href: company?.ContactUS, text: "تماس با ما", onClick: closeMenu, icon: <PhoneVibrate style={{ marginTop: "6px", color: 'rgb(47 18 161)' }} size={18} /> },
            { type: "a", href: company?.WebSite, text: "سایت شرکت", onClick: closeMenu, icon: <Globe2 style={{ marginTop: "6px", color: 'rgb(165 21 21)' }} size={16} /> },
            { type: "link", to: '/RequestPassword', text: "تغییر رمز", onClick: closeMenu, icon: <Key style={{ marginTop: "5px", color: '#ff0094' }} size={20} /> },
            { type: "link", to: "/Profile", text: "پروفایل من", onClick: closeMenu, icon: <Person style={{ marginTop: "6px", color: 'blue' }} size={20} /> },
          ]} />
        </div>
        <div className="menuFooter" >
          <InfoSquare size={20} style={{ cursor: "pointer" }} color={"rgb(115, 57, 141)"} onClick={() => setModalAboutUs(true)} />
          <p style={{ marginTop: "4px" }}>Powered By Bihamta</p>
          <p >تهیه و تولید از شرکت هورماه</p>
          <p >شماره نسخه: {pkg.version}</p>
        </div>

      </div>
    </Fragment>)
}
export default MenuWide;